
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import {pathConstants} from "../shared/pathConstants";
import Vue from "vue";

export const publicService = {
    getAppInfo,
};

function getAppInfo() {
  return axios
    .get(pathConstants.API + "/public/info",{ headers: { publicService: true } })
    .then(result => {
          if (result.data) {
              return result.data;
          } else {
              return null;
          }
      }, err => {
          Vue.$log.error("fetching app info", err);
      });
}

